import React, { useEffect, useState } from 'react';
import { boardAPI } from '../../../api';
import api from '../../../api/axios';

const AdminNotices: React.FC = () => {
  const [notices, setNotices] = useState<any[]>([]);
  const [form, setForm] = useState({ title: '', content: '', is_important: false });
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState<number | null>(null);
  const [editForm, setEditForm] = useState({ title: '', content: '', is_important: false });

  const load = async () => {
    const res = await boardAPI.notices();
    setNotices(res.data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.title || !form.content) { alert('제목과 내용을 입력해주세요.'); return; }
    try {
      await api.post('/api/board/notices/', form);
      setForm({ title: '', content: '', is_important: false });
      await load();
      alert('등록되었습니다.');
    } catch (e) { alert('등록 실패'); }
  };

  const del = async (id: number) => {
    if (!window.confirm('삭제하시겠습니까?')) return;
    try { await api.delete(`/api/board/notices/${id}/`); await load(); } catch (e) {}
  };

  const startEdit = (n: any) => {
    setEditId(n.id);
    setEditForm({ title: n.title, content: n.content, is_important: n.is_important });
  };

  const cancelEdit = () => {
    setEditId(null);
    setEditForm({ title: '', content: '', is_important: false });
  };

  const saveEdit = async () => {
    if (!editForm.title || !editForm.content) { alert('제목과 내용을 입력해주세요.'); return; }
    try {
      await api.patch(`/api/board/notices/${editId}/`, editForm);
      cancelEdit();
      await load();
      alert('수정되었습니다.');
    } catch (e) { alert('수정 실패'); }
  };

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div className="admin-page-title"><span className="icon">📢</span>공지사항</div>
      </div>
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-header">새 공지사항 등록</div>
        <div className="card-body">
          <div className="form-group">
            <label className="form-label">제목</label>
            <input className="form-control" value={form.title} onChange={e => setForm({...form, title: e.target.value})} placeholder="공지사항 제목" />
          </div>
          <div className="form-group">
            <label className="form-label">내용</label>
            <textarea className="form-control" rows={4} value={form.content} onChange={e => setForm({...form, content: e.target.value})} placeholder="공지사항 내용" style={{ resize: 'vertical' }} />
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, cursor: 'pointer', marginBottom: 16 }}>
            <input type="checkbox" checked={form.is_important} onChange={e => setForm({...form, is_important: e.target.checked})} />
            중요 공지로 설정
          </label>
          <button className="btn btn-primary" onClick={create}>📝 등록</button>
        </div>
      </div>
      <div className="card">
        <div className="card-body" style={{ padding: 0 }}>
          {loading ? <div className="loading-spinner"><div className="spinner" /></div> : (
            <table className="table">
              <thead>
                <tr><th>번호</th><th>제목</th><th>작성일</th><th>조회</th><th style={{ width: 140 }}>관리</th></tr>
              </thead>
              <tbody>
                {notices.map((n: any) => (
                  <React.Fragment key={n.id}>
                    {editId !== n.id ? (
                      <tr>
                        <td style={{ textAlign: 'center', width: 60 }}>{n.is_important ? <span className="badge badge-danger">중요</span> : n.id}</td>
                        <td style={{ fontWeight: 500 }}>{n.title}</td>
                        <td style={{ color: 'var(--text-muted)', fontSize: 12 }}>{n.created_at?.slice(0,10)}</td>
                        <td style={{ textAlign: 'center', color: 'var(--text-muted)' }}>{n.views}</td>
                        <td>
                          <div style={{ display: 'flex', gap: 4 }}>
                            <button className="btn btn-sm" style={{ background: '#f0f9ff', color: '#0369a1', border: '1px solid #bae6fd' }} onClick={() => startEdit(n)}>✏️ 수정</button>
                            <button className="btn btn-danger btn-sm" onClick={() => del(n.id)}>삭제</button>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      <tr style={{ background: '#fffbeb' }}>
                        <td colSpan={5} style={{ padding: 16 }}>
                          <div className="form-group" style={{ marginBottom: 10 }}>
                            <input className="form-control" value={editForm.title} onChange={e => setEditForm({...editForm, title: e.target.value})} placeholder="제목" style={{ fontSize: 14 }} />
                          </div>
                          <div className="form-group" style={{ marginBottom: 10 }}>
                            <textarea className="form-control" rows={4} value={editForm.content} onChange={e => setEditForm({...editForm, content: e.target.value})} placeholder="내용" style={{ resize: 'vertical', fontSize: 14 }} />
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, cursor: 'pointer' }}>
                              <input type="checkbox" checked={editForm.is_important} onChange={e => setEditForm({...editForm, is_important: e.target.checked})} />
                              중요 공지로 설정
                            </label>
                            <div style={{ display: 'flex', gap: 8 }}>
                              <button className="btn btn-primary btn-sm" onClick={saveEdit}>💾 저장</button>
                              <button className="btn btn-ghost btn-sm" onClick={cancelEdit}>취소</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminNotices;
